<div #shellScriptsJS class="fwk-shell-hidden-scripts"></div>

<router-outlet
  *ngIf="
    urlReplaceServiceLoaded &&
    webComponentLoadingServiceLoaded &&
    testEnvironmentServiceLoaded
  "
></router-outlet>
